import React, { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import RefreshToken from "./RefreshToken";
import { connect } from "react-redux";
import Loader from "App/utils/Loader";
import ToastMessage from "App/common/ToastMessage";
import Maintaince from "App/common/Maintaince";

// Add chunk names for better code splitting
const AuthLayout = lazy(() => import(/* webpackChunkName: "auth-layout" */ "App/common/AuthLayout"));
const AppLayout = lazy(() => import(/* webpackChunkName: "app-layout" */ "App/common/AppLayout"));
const PaymentRoutes = lazy(() => import(/* webpackChunkName: "payment-routes" */ "App/common/PaymentRoutes"));
const SessionPage = lazy(() => import(/* webpackChunkName: "session-page" */ "App/screens/auth/SessionPage"));
// FR-13 #10 — public shared-ETA tracking page. Mounted at the top
// level so it doesn't go through the AuthLayout / AppLayout (which
// would force a login redirect).
const SharedTrack = lazy(() => import(/* webpackChunkName: "shared-track" */ "App/screens/sharedTrack/SharedTrack"));

interface AppNavigatorProps {
  refreshTokenLoaded: boolean;
  globalData: any;
}

const sessionParam = new URLSearchParams(window.location.search).get('session');

const AppNavigator = ({
  refreshTokenLoaded,
  globalData,
}: AppNavigatorProps) => {
  const isMaintenanceMode = globalData?.maintainceMode;
  const maintenanceTitle = globalData?.maintainceObj?.title;

  if (sessionParam) {
    return (
      <Suspense>
        <BrowserRouter>
          <SessionPage />
        </BrowserRouter>
      </Suspense>
    );
  }

  return (
    <>
      <ToastMessage />
      <RefreshToken />
      {isMaintenanceMode && (
        <Maintaince isVisible={true} title={maintenanceTitle} />
      )}
      {refreshTokenLoaded ? (
        <Suspense>
          <BrowserRouter>
            <Routes>
              <Route path="/payment/*" Component={PaymentRoutes} />
              {/* FR-13 #10 — public shared-ETA. Token in URL is the
                  only auth; receiver doesn't need an account. */}
              <Route path="/track/:token" Component={SharedTrack} />
              <Route path="/*" Component={AuthLayout} />
              <Route path="/app/*" Component={AppLayout} />
            </Routes>
          </BrowserRouter>
        </Suspense >
      ) : (
        <Loader message="Loading..." size={30} />
      )}
    </>
  );
};

const mapStateToProps = (state: any) => ({
  refreshTokenLoaded: state.user.refreshTokenLoaded,
  globalData: state.auth.globalData,
});

export default connect(mapStateToProps, null)(AppNavigator);
